import { FC } from 'react'

import dayjs from 'dayjs'

import {
  CampaignDetailsAutoRenewBlock,
  CampaignDetailsAutoRenewBlockProps,
} from 'src/Components/CampaignDetailsAutoRenewBlock'
import { useSetMetaAdsAutoRenewalMutation } from 'src/Redux/metaAdsDetailsApi'

interface Props {
  campaignId?: number
  shouldAutoRenew?: boolean
  endDate?: string
  daysCount?: null | number
  className?: string
}

export const MetaAdsAutoRenewBlock: FC<Props> = ({
  campaignId,
  shouldAutoRenew,
  endDate,
  daysCount,
  className,
}) => {
  const [setAutoRenewal] = useSetMetaAdsAutoRenewalMutation()

  const handleToggle = (nextValue: boolean): void => {
    if (!campaignId) {
      return
    }
    setAutoRenewal({
      campaignId: String(campaignId),
      shouldAutoRenew: nextValue,
    })
  }

  const activeStateProps: Pick<
    CampaignDetailsAutoRenewBlockProps,
    'renewalDate' | 'duration'
  > = {}

  if (endDate) {
    activeStateProps.renewalDate = dayjs(endDate).utc().format('DD MMM, YYYY')
  }
  if (typeof daysCount === 'number') {
    activeStateProps.duration = daysCount
  }

  return (
    <CampaignDetailsAutoRenewBlock
      className={className}
      isActive={Boolean(shouldAutoRenew)}
      onEnable={() => handleToggle(true)}
      onDisableConfirm={() => handleToggle(false)}
      {...activeStateProps}
    />
  )
}
